import { emitFunnelEvent } from '@/lib/funnel-events'

export type SignInClickedPayload = {
  source: string
  mpid?: string
  framer_user_id?: string
  has_mpid: boolean
  has_framer_user_id: boolean
}

/** Framer → auth landing attribution (fire-and-forget). */
export function trackSignInClicked(payload: SignInClickedPayload): void {
  emitFunnelEvent('sign_in_clicked', 'auth', {
    source: payload.source,
    mpid: payload.mpid,
    framer_user_id: payload.framer_user_id,
    has_mpid: payload.has_mpid,
    has_framer_user_id: payload.has_framer_user_id,
  })
}
